import { TURN_DURATION, TURN_SHIFT_START } from './character_list_2_appearance.js';

const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
const RESTORE_END = 480;
const OPEN_END = 720;

export function hasPositionChange(delta, { closing = 0, opening = 0 } = {}) {
  return [delta, closing, opening].some(value => Math.abs(value) >= 0.5);
}

// Closing the previous panel and opening the next can cancel in final layout,
// even though the intervening cards must move through both stages. Preserve
// those contributions separately instead of animating only the final delta.
export function positionFrames(delta, { closing = 0, opening = 0, elapsed = 0 } = {}) {
  const remaining = Math.max(1, TURN_DURATION - elapsed);
  const frames = [{ transform: `translateX(${delta}px)`, offset: 0, easing: EASE }];
  for (const [time, translation] of [
    [TURN_SHIFT_START, delta - closing],
    [RESTORE_END, -opening],
    [OPEN_END, 0]
  ]) {
    if (time <= elapsed) continue;
    frames.push({ transform: `translateX(${translation}px)`, offset: (time - elapsed) / remaining, easing: EASE });
  }
  frames.push({ transform: 'translateX(0px)', offset: 1 });
  return frames;
}

function bounded(value, total) {
  return total >= 0 ? Math.max(0, Math.min(total, value)) : Math.min(0, Math.max(total, value));
}

// Capture before morphing, using the current rendered slot translation. That
// gives the exact remaining eased distance without approximating a CSS curve.
// The next animation stores its own delta/remaining contributions and elapsed
// value, so successive updates continue the same overall turn timeline.
export function remainingPositionStages(timeline, currentTime, currentTranslation) {
  const { delta, closing = 0, opening = 0, elapsed = 0 } = timeline;
  const time = Math.min(TURN_DURATION, elapsed + Math.max(0, Number(currentTime) || 0));
  return {
    closing: time < TURN_SHIFT_START ? bounded(currentTranslation - (delta - closing), closing) : 0,
    opening: time < RESTORE_END ? opening : time < OPEN_END ? bounded(-currentTranslation, opening) : 0,
    elapsed: time
  };
}
